<template>
  <div style="padding: 5px;">
    <a-card>
      <div style="text-align: right;">
        <span
          class="ant-descriptions-title"
          style="float: left; margin-top: 5px;"
        >
          <a-icon type="tags" /> List document type
        </span>
        <a-input
          placeholder="Search..."
          style="width: 350px; max-width: 100%; margin-right: 5px;"
          v-model="keySearch"
          @change="onFilter"
        />
        <a-button
          slot="extra"
          type="primary"
          @click="showDrawerAddDocumentType"
        >
          <a-icon type="plus" /> Add
        </a-button>
      </div>

      <a-drawer
        v-if="visibleAddDocumentType"
        title="Add"
        placement="right"
        :visible="visibleAddDocumentType"
        @close="closeDrawerAddDocumentType"
        :width="450"
      >
        <AppDocumentType
          :closeDrawerAddDocumentType="closeDrawerAddDocumentType"
          :createdDocumentTypeOnView="createdDocumentTypeOnView"
        />
      </a-drawer>

      <a-drawer
        v-if="visibleUpdateDocumentType"
        title="Edit"
        placement="right"
        :visible="visibleUpdateDocumentType"
        @close="closeDrawerUpdateDocumentType"
        :width="450"
      >
        <UpdateDocumentType
          :closeDrawerUpdateDocumentType="closeDrawerUpdateDocumentType"
          :updateDocumentTypeOnView="updateDocumentTypeOnView"
          :deleteDocumentTypeOnView="deleteDocumentTypeOnView"
          :idDocumentType="idDocumentType"
        />
      </a-drawer>

      <a-table
        :loading="loading"
        size="small"
        :columns="columnDocumentType"
        :data-source="listDocumentType"
        rowKey="id"
        style="margin-top: 5px;"
        :pagination="{
          current: currentPage,
          onChange: (page) => {
            this.currentPage = page;
          },
          pageSize: limit,
        }"
      >
        <div slot="stt" slot-scope="text, record, index">
          {{ index + 1 }}
        </div>

        <div slot="createdAt" slot-scope="text, record">
          <p>
            {{ record.createdAt | formatDateHour }}
          </p>
        </div>

        <div slot="updatedAt" slot-scope="text, record">
          <p>
            {{ record.updatedAt | formatDateHour }}
          </p>
        </div>

        <div slot="action" slot-scope="text, record">
          <a-button
            icon="edit"
            @click="showDrawerUpdateDocumentType(record)"
            class="icon-update"
          >
            Edit
          </a-button>
        </div>

        <div slot="footer">
          <a-button
            :loading="loading"
            type="link"
            @click="pagination"
            :disabled="disabledButtonPagination"
          >
            <a-icon type="reload" /> Load more
          </a-button>
        </div>
      </a-table>
    </a-card>
  </div>
</template>
<script>
import debounce from "lodash/debounce";
import AppDocumentType from "./components/addDocumentType";
import UpdateDocumentType from "./components/updateDocumentType";
import getQuery from "../data/getData";
import { columnDocumentType } from "../Constants/dataColumns";
import {
  updateForCreated,
  updateForUpdated,
  updateForDeleted,
} from "@/services/updateOnViewConfig";

const limit = 10;
const startPage = 1;
export default {
  components: {
    AppDocumentType,
    UpdateDocumentType,
  },
  data() {
    this.onFilter = debounce(this.onFilter, 800);
    return {
      limit,
      idDocumentType: null,
      visibleAddDocumentType: false,
      visibleUpdateDocumentType: false,
      currentPage: startPage,
      totalPage: startPage,
      disabledButtonPagination: false,
      loading: true,
      columnDocumentType,
      listDocumentType: [],
      keySearch: "",
    };
  },
  methods: {
    updateDocumentTypeOnView(item) {
      this.listDocumentType = updateForUpdated(this.listDocumentType, item);
    },
    createdDocumentTypeOnView(item) {
      this.listDocumentType = updateForCreated({
        list: this.listDocumentType,
        item,
        limit,
        currentPage: this.totalPage,
      });
    },
    deleteDocumentTypeOnView(item) {
      this.listDocumentType = updateForDeleted(this.listDocumentType, item);
    },

    showDrawerAddDocumentType() {
      this.visibleAddDocumentType = true;
    },
    closeDrawerAddDocumentType() {
      this.visibleAddDocumentType = false;
    },

    showDrawerUpdateDocumentType(record) {
      this.idDocumentType = record.id;
      this.visibleUpdateDocumentType = true;
    },
    closeDrawerUpdateDocumentType() {
      this.visibleUpdateDocumentType = false;
    },
    goToDocumentType(record) {
      this.$router.push({
        name: "updateDocumentType",
        params: { idDocumentType: record.id },
      });
    },

    onFilter() {
      this.currentPage = 1;
      this.totalPage = 1;
      this.listDocumentType = [];
      this.getAllDocumentType();
    },

    pagination() {
      this.totalPage += 1;
      this.currentPage = this.totalPage;
      this.getAllDocumentType();
    },
    getAllDocumentType() {
      this.loading = true;
      this.$apollo
        .query({
          query: getQuery.queryGetAllDocumentType,
          variables: {
            page: this.currentPage,
            query: this.keySearch,
            limit,
          },
        })
        .then(({ data }) => {
          if (data?.getAllDocumentType?.length >= 0) {
            if (data.getAllDocumentType.length < limit) {
              this.disabledButtonPagination = true;
            } else {
              this.disabledButtonPagination = false;
            }
            this.listDocumentType = [
              ...this.listDocumentType.concat(data.getAllDocumentType),
            ];
          }

          this.loading = false;
        })
        .catch((error) => {
          console.log("Không lấy được danh sách loại công văn", error);
        });
    },
  },
  created() {
    this.getAllDocumentType();
  },
};
</script>
